<script>
import { ValidationObserver } from 'vee-validate'

export default {
  components: { ValidationObserver },
  props: {
    user: {
      type: String,
      required: true,
    },

    options: {
      type: Object,
      required: true,
    },
    value: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      form: [],

      savedData: [],
      storeData: {},
      index: null,
      restrict: null,
    }
  },
  watch: {
    value(oldVal, newVal) {
      if (oldVal !== newVal)
        this.savedData =
          this.value !== undefined && this.value !== null ? this.value : []
    },
  },

  mounted() {
    this.savedData =
      this.value !== undefined && this.value !== null ? this.value : []

    // console.log(this.savedData)
    //  let apiString = services.apiService(this.api.get, this.user.id, null)
    // this.getData(apiString)
  },
  beforeDestroy() {
    var doc = this.$refs[this.options.title + 'addmore']
    if (doc !== undefined) doc.innerHTML = ''
  },
  created() {
    // console.log(this.options.options)
    this.form = [
      {
        value: 'documentType',

        name: 'Document type',
        typeComponent: 'FormBaseSelect',
        type: 'select',
        form: 'supporting documents',
        validation: { required: true },
        label: 'Uploading document type',
        options: this.options,
      },
      {
        value: this.options.file.name,

        name: this.options.file.name,
        typeComponent: 'FormBaseFile',
        type: 'file',
        form: 'supporting documents',
        validation: 'ext:jpg,png,pdf,jpeg|size:15000|required',
        label: 'Upload document',
        options: this.options.file.options,
      },
    ]
  },
  methods: {
    deleteData(index, event) {
      this.savedData[index][event.name] = event.data

      this.$emit('delete', this.savedData)
    },
    sendData(index, event) {
      //    console.log(event)
      this.savedData[index][event.name] = event.data
      this.$emit('update', this.savedData)
      this.data = this.savedData
    },
    hide(name) {
      this.$bvModal.hide(name)
    },
    openModal(index, modal) {
      if (index !== null) {
        this.index = index
        this.storeData = this.savedData[index]
        //     console.log(this.options.file.name)
      } else this.storeData = {}
      this.$bvModal.show(modal)
    },
    cancel(key) {
      this.$bvModal.hide('supporting-documents')
    },
    deleteRecord(id) {
      var data = this.savedData[id]
      var ind = this.form.findIndex(
        (element) => element.typeComponent === 'FormBaseFile'
      )
      // console.log(ind)
      if (ind !== -1) {
        var fileName = this.form[ind].value
        if (data[fileName] !== undefined)
          this.$root.$emit('deleteFile', data[fileName])
      }
      this.savedData.splice(id, 1)
      this.$emit('update', this.savedData)
      //   console.log(this.savedData)
    },
    saveData() {
      // var id = this.user.personalInfo.id
      // console.log(name)

      this.$refs.form.validate().then((success) => {
        if (success) {
          if (this.index === null) {
            this.savedData.push(this.storeData)
            this.$emit('update', this.savedData)
            this.$bvModal.hide('supporting-documents')
            /*  let api = services.apiService(this.api.post, this.user.id, null)
            this.postData(api) */
          } else {
            /* let api = services.apiService(
              this.api.put,
              this.user.id,
              this.storeData['id']
            )
            this.putData(api, this.storeData['id']) */
            this.$bvModal.hide('supporting-documents')
            this.savedData[this.index] = this.storeData
            this.$emit('update', this.savedData)
          }
        }
      })
    },
  },
}
</script>
<template>
  <div :ref="options.title + 'addmore'">
    <div class="clear"></div>
    <div :class="$style.guideBoard" class="mt30 ">
      <span :class="$style.guideBoardIcon"></span>
      <p :class="$style.guideBoardText"><b>Note : </b>{{ options.info }}</p>
      <div class="clear"></div>
    </div>

    <div :key="savedData.length" :class="$style.addMainWraper">
      <!-- <label :class="$style.fieldTitle" class="w40 w100-sm FL pr15 pr0-sm"
        >{{ options.title }}:
      </label> -->
      <div class="clear"></div>
      <div
        v-for="(data, key) in savedData"
        :key="key"
        :class="$style.addMoreSeperate"
        class="mt30"
      >
        <div :class="$style.collapseHeader">
          <label :class="$style.collapseTitle"
            >{{ options.title + ' ' + (key + 1) }}:
          </label>
          <a
            href="javascript:void(0)"
            :class="$style.closeThis"
            @click="deleteRecord(key)"
            ><BIcon class="" icon="trash" :class="$style.closeIcon"></BIcon
          ></a>
          <div class="clear"></div>
        </div>
        <div class="pt10 pr30 pb30 pl30">
          <FormBaseBuilder
            :key="key"
            :value="data"
            :form="[
              {
                value: 'documentType',

                name: 'Document type',
                typeComponent: 'FormBaseSelect',
                type: 'select',
                form: 'supporting documents',
                validation: { required: true },
                label: 'Uploading document type',
                options: options,
              },
              {
                value: options.file.name,
                id: options.file.name + key,
                name: options.file.name,
                typeComponent: 'FormBaseFile',
                type: 'file',
                form: 'supporting documents',
                validation: 'ext:jpg,png,pdf,jpeg|size:15000|required',
                label: 'Upload document',
                options: options.file.options,
              },
            ]"
            :user="user"
            @update="sendData(key, $event)"
            @edit="sendData(key, $event)"
            @delete="deleteData(key, $event)"
          />
          <div class="clear"></div>
          <!-- <div :class="$style.bodyContentBorder"></div> -->
        </div>
      </div>
    </div>

    <div class="clear"></div>
    <a
      v-if="
        restrict !== null ? (saveData.length < restrict ? true : false) : true
      "
      href="javascript:void(0)"
      :class="[$style.addMoreButton, $style.nameIcon]"
      class="FL d-block mt20"
      @click="savedData.push({})"
      ><b>+</b>{{ savedData.length > 0 ? options.button2 : options.button1 }}</a
    >
    <div class="clear"></div>
    <div :class="$style.bodyContentBorder"></div>
    <div>
      <b-modal
        id="supporting-documents"
        centered
        title="BootstrapVue"
        hide-header
        hide-footer
        size="md"
      >
        <div :class="$style.modalWraper">
          <div :class="$style.modalHeader">
            <h3 :class="$style.modalTitle">{{ options.title }}</h3>
            <a
              href="javascript:void(0)"
              :class="$style.modalClose"
              @click="hide('supporting-documents')"
              ><BIcon class="" icon="x" :class="$style.modalCloseIcon"></BIcon
            ></a>
            <div class="clear"></div>
          </div>
          <div class="clear"></div>
          <div :class="$style.modalBody">
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
              <form
                :class="$style.form"
                @submit.prevent="handleSubmit(saveData)"
              >
                <FormBaseBuilder
                  :value="storeData"
                  :form="form"
                  :user="user"
                  @update="sendData"
                  @edit="sendData"
                  @delete="deleteData"
                />

                <div class="clear"></div>
                <div :class="[$style.buttonWrapper]" class=" mt25 tc">
                  <button
                    type="button"
                    class="buttonCommon buttonCancel button mr20 mb20-xs"
                    @click="cancel(key)"
                  >
                    Cancel
                  </button>
                  <button
                    class="buttonCommon buttonPrimary button"
                    type="submit"
                    v-on="$listeners"
                  >
                    Update
                  </button>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.closeThis {
  position: relative;
  display: block;
  float: right;
  width: 29px;
  height: 29px;
  font-size: 15px;
  color: #f05e54;
  text-align: center;
  background: #fbe2e0;
  border-radius: 50px;

  .closeIcon {
    position: absolute;
    top: 7px;
    left: 7px;
    color: #f05e54;
  }
}

.addMoreSeperate {
  overflow: hidden;
  border: 1px solid #f4f4f4;
  border-radius: 10px;
}
.collapseHeader {
  width: 100%;
  padding: 10px 30px;
  background: #fafafa;
  border-bottom: 1px solid #f4f4f4;
}
.collapseTitle {
  margin-right: 20px;
  margin-bottom: 0;
  font-family: 'LexendDecaRegular', Helvetica Neue, sans-serif,
    Apple Color Emoji;
  font-size: 15px;
  color: #697783;
  text-align: left;
}
.bodyContentBorder {
  width: 100%;
  height: 2px;
  margin: 30px 0;
  background: #f8f9f9;
}

// Add more button
.addMoreButton {
  position: relative;
  padding: 2px 20px;
  font-family: 'LexendDecaRegular', Helvetica Neue, sans-serif,
    Apple Color Emoji;
  font-size: 14px;
  line-height: 31px;
  color: #fff !important;
  text-decoration: none !important;
  background: #60e8bb;
  border: 1px solid #60e8bb;
  border-radius: 50px;
  transition: all ease-in-out 0.3s;

  &:hover {
    color: $color-main-button !important;
    background: #fff;
    border: 1px solid $color-main-button;
    transition: all ease-in-out 0.3s;
  }
}
// Add more button

// Instruction message
.guideBoard {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% + 60px);
  padding: 15px;
  margin-left: -30px;
  background: #fff5f1;

  .guideBoardIcon {
    position: relative;
    float: left;
    width: 45px;
    height: 45px;
    margin-right: 10px;
    background: #b9d3fa;
    border-radius: 50px;

    &::after {
      position: absolute;
      top: 0;
      left: 1px;
      width: 72px;
      height: 72px;
      content: '';
      background: url('~@assets/images/icon.png') no-repeat;
      background-position: 0 0;
      transform: scale(0.61);
      transform-origin: 0 0;
    }
  }

  .guideBoardText {
    float: left;
    width: calc(100% - 55px);
    margin: 8px 0 0;
    font-family: 'RobotoRegular', Helvetica Neue, sans-serif, Apple Color Emoji;
    font-size: 12px;
    line-height: 16px;
    color: #757b82;
  }
}
// Instruction message

// Modal

.modalWraper {
  .modalHeader {
    padding: 25px 30px;
    background: #fafafa;
    border-bottom: 1px solid #ebebeb;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .modalTitle {
    float: left;
    margin: 5px 0 0 0;
    font-family: 'OpenSansRegular', Helvetica Neue, sans-serif,
      Apple Color Emoji;
    font-size: 20px;
    color: #808183;
  }

  .modalClose {
    position: relative;
    display: block;
    float: right;
    width: 32px;
    height: 32px;
    font-size: 23px;
    line-height: 30px;
    color: #8b8d90;
    text-align: center;
    background: #eceff1;
    border-radius: 50px;

    .modalCloseIcon {
      position: absolute;
      top: 4px;
      left: 5px;
    }
  }

  .modalBody {
    padding: 25px 30px 40px 30px;
  }

  .guideBoard {
    width: calc(100% + 80px);
    margin-left: -40px;
  }

  .formGroup {
    max-width: 100% !important;
  }
}
// Modal
</style>
